import React, { Component } from "react";
import { connect } from "react-redux";
import { number, string } from "prop-types";

import FaceCaptureUI from "../FaceCaptureUI";
import { Modal } from "react-bootstrap";
import NativeCaptureBox from "../NativeCaptureBox";
import VisiblityChangeHandler from "../VisiblityChangeHandler";
import TimeoutVisibility from "../TimeoutVisibility";
import PageContent from "../PageContent";
import { preview } from "../../logic/actions/faceCapture";
import frameOverlayGreen from "../../assets/frame_overlay_far_green.png";
import {
  logEvent,
  FACE_CAPTURE_STARTED,
  FACE_CAPTURED,
  FACE_CAPTURE_NATIVE,
  RETRY_CAMERA_INIT,
} from "../../logic/eventLogger";
import CaptureButtonPanel from "../CaptureButtonPanel";
import { toggleNetworkWarnings } from "../../logic/actions/apiFetch";
import { CONNECTION_ISSUES } from "../../logic/enums/errorMessages";

const START = 0;
const CAPTURING = 1;
const PASS = 2;

const CAPTURE_METHOD = {
  WEBRTC: "WEBRTC",
  NATIVE: "NATIVE",
};

export class PageFaceCapture extends Component {
  static propTypes = {
    retries: number,
    faceQualityHostname: string,
  };
  constructor(props) {
    super(props);
    this.canvasRef = new React.createRef();

    this.state = {
      message: "",
      formState: START,
      captureMethod: CAPTURE_METHOD.WEBRTC,
      cameraPermission: true,
      retryCameraInit: false,
      shouldStartNativeCamera: false,
      wasmIsLoading: true,
    };
    this.onCameraStarted.bind(this);
  }

  componentDidMount() {
    if (window.navigator.userAgent.indexOf("Edge") > -1) {
      this.canvas = this.refs.canvas;
      this.ctx = this.canvas.getContext("2d");

      this.imageGreen = new Image();
      this.imageGreen.src = frameOverlayGreen;
      this.imageGreen.onload = () => {
        this.drawOutline(this.imageGreen);
      };
    }

    // this.retryCameraInit();
  }

  componentWillUnmount() {
    if (
      this.state.fc &&
      typeof this.state.fc.destroy === "function" &&
      this.state.cameraPermission
    ) {
      this.state.fc.destroy();
    }

    if (this.video) {
      this.video.onloadedmetadata = null;
      this.video = null;
    }
  }

  onVisibilityChange = (isVisible) => {
    if (isVisible) {
      if (this.state.unfocusedPage) this.state.fc.startCamera();
      this.setState({ unfocusedPage: false });
    } else {
      this.state.fc.destroy();
      this.state.fc.stopCamera();
      this.setState({ unfocusedPage: true });
    }
  };

  drawOutline(img) {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    let scale = 1.2;

    let dx = (this.canvas.width - img.width * scale) / 2;
    let dy = (this.canvas.height - img.height * scale * 1.4) / 2;

    this.ctx.globalAlpha = 0.7;
    this.ctx.drawImage(
      img,
      dx,
      dy,
      img.width * scale,
      img.height * scale * 1.4
    );
  }

  onCameraStarted = (fc, video) => {
    this.video = video;
    this.video.onloadedmetadata = () => {
      fc.startFaceDetector({
        urlFaceDetectorWasm:
          window.location.origin + "/DaonFaceQualityLite.wasm",
        onFaceDetectorInitialized: function () {
          fc.findFace();
        },
        onFaceDetectorError: function (err) {
          console.error("DEMO FaceDetector error", err);
        },
        onFaceDetection: (coords) => {
          this.setState({ wasmIsLoading: false });
          setTimeout(() => {
            this.state.fc.findFace();
          }, 1000);
          if (coords) {
            if (!this.state.faceFound) this.setState({ faceFound: true });
          } else {
            if (this.state.faceFound) {
              this.setState({
                faceFound: false,
                formState: START,
                message:
                  "Stay still and keep your face inside oval while taking selfie",
              });
              this.state.fc.stopAutoCapture();
            }
          }
        },
      });
    };
  };

  captureFeedback(response, calledFrom) {
    if (
      calledFrom !== this.state.captureMethod ||
      this.state.formState === PASS
    )
      return;
    this.setState({
      pending: false,
      isError: false,
    });
    if (response.result === "PASS") {
      logEvent(FACE_CAPTURED);
      this.state.fc.stopAutoCapture();

      this.setState({
        message: "",
        formState: PASS,
      });
      this.props.toggleNetworkWarnings(false);
      this.props.preview({
        blob: response.sentBlobImage,
        isRejected: false,
        captureMethod: this.state.captureMethod,
      });
    } else {
      if (calledFrom === CAPTURE_METHOD.NATIVE) {
        this.setState({
          pending: false,
          formState: START,
          message: response.feedback || response.message,
        });

        this.props.preview({
          blob: response.sentBlobImage,
          isRejected: true,
          message: response.result
            ? response.feedback || response.message
            : CONNECTION_ISSUES,
          captureMethod: this.state.captureMethod,
        });
      } else {
        this.setState({
          message: response.feedback || response.message,
        });
      }
    }
  }

  captureError(err, calledFrom) {
    if (
      calledFrom !== this.state.captureMethod ||
      this.state.formState === PASS
    )
      return;

    let message =
      "An error has occured. Please try again and if the problem persist, contact your support.";

    if (err instanceof DOMException && err.name === "AbortError") {
      message = CONNECTION_ISSUES;
    }

    this.setState({
      pending: false,
      formState: START,
      message,
      isError: true,
    });
    //TODO@gva: When error occurs on native , camera is not active and we cannot start webrtc capture

    this.props.toggleNetworkWarnings(false);
  }

  startAutoCapture() {
    logEvent(FACE_CAPTURE_STARTED);
    this.setState({
      captureMethod: CAPTURE_METHOD.WEBRTC,
      formState: CAPTURING,
      message: "",
      isError: false,
    });
    this.props.toggleNetworkWarnings(true);
    this.state.fc.startAutoCapture(
      (response) => this.captureFeedback(response, CAPTURE_METHOD.WEBRTC),
      (error) => this.captureError(error, CAPTURE_METHOD.WEBRTC)
    );
  }

  handleShowNativeInstructions = () => {
    this.state.fc.stopCamera();
    this.setState({ nativeInstructions: true });
  };

  handleCloseNativeInstructions = () => {
    this.setState({ nativeInstructions: false });
    this.state.shouldStartNativeCamera
      ? this.setState({ shouldStartNativeCamera: false })
      : this.setState({ shouldStartNativeCamera: true });
  };

  switchToNative() {
    this.state.fc.stopAutoCapture();
    this.setState({ captureMethod: undefined });
  }

  nativeCapture(blob) {
    logEvent(FACE_CAPTURE_NATIVE);
    this.state.fc.stopAutoCapture();
    this.setState({
      captureMethod: CAPTURE_METHOD.NATIVE,
      pending: true,
      formState: CAPTURING,
    });
    this.props.toggleNetworkWarnings(true);
    this.state.fc
      .assessQuality({ blob })
      .then((response) => this.captureFeedback(response, CAPTURE_METHOD.NATIVE))
      .catch((error) => this.captureError(error, CAPTURE_METHOD.NATIVE))
      .finally(() => this.props.toggleNetworkWarnings(false));
  }

  cameraPermissionDenied = () => {
    this.setState({
      cameraPermission: false,
      message:
        "Please go to browser settings, enable camera permission and then click on button to confirm.",
      isError: true,
      retryCameraInit: false,
      wasmIsLoading: false,
    });
  };

  retryCameraInit = () => {
    logEvent(RETRY_CAMERA_INIT);
    if (!this.state.cameraPermission)
      this.setState({
        cameraPermission: true,
        retryCameraInit: true,
        message: "",
        isError: false,
      });
  };

  render() {
    const message =
      this.state.message ||
      "Position your face inside the marked area and click the start button when you are ready";
    const messageClass = `message-box box-shadow ${
      this.state.isError ? "message-box-error" : ""
    }`;
    return (
      <PageContent
        toggleLoading={this.state.pending || this.state.wasmIsLoading}
        type="capture"
      >
        <VisiblityChangeHandler onVisibilityChange={this.onVisibilityChange} />
        <TimeoutVisibility timeout={15000} visible={true}>
          <NativeCaptureBox
            onClick={() => this.switchToNative()}
            onUploaded={(blob) => this.nativeCapture(blob)}
            facingMode="user"
            imageType="selfie"
            handleShowNativeInstructions={this.handleShowNativeInstructions}
            shouldStartNativeCamera={this.state.shouldStartNativeCamera}
          />
        </TimeoutVisibility>
        <p className="take-a-selfie">Take a selfie</p>
        <FaceCaptureUI
          onInitialized={(fc) => this.setState({ fc })}
          onCameraStarted={this.onCameraStarted}
          url={this.props.faceQualityHostname + "/rest/v1/quality/assessments"}
          className={"overlay overlay-oval"}
          cameraPermissionDenied={this.cameraPermissionDenied}
          retryCameraInit={this.state.retryCameraInit}
        />

        {window.navigator.userAgent.indexOf("Edge") > -1 ? (
          <canvas
            className="ui-canvas-container ui-canvas"
            ref="canvas"
            width={480}
            height={640}
          />
        ) : null}
        <Modal
          show={this.state.nativeInstructions}
          onHide={this.handleCloseNativeInstructions}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <p>
                <strong>
                  Please make sure you can see your face fully, positioned in
                  the center of the screen.
                </strong>
              </p>
            </Modal.Title>
          </Modal.Header>
        </Modal>

        <footer>
          <div className={messageClass}>{message}</div>
          {this.state.formState === START && this.state.cameraPermission && (
            <CaptureButtonPanel
              onCaptureClick={() => this.startAutoCapture()}
              disabled={!this.state.faceFound}
              text="Start"
            />
          )}
          {!this.state.cameraPermission && (
            <button className={"btn blue"} onClick={this.retryCameraInit}>
              CONFIRM CAMERA PERMISSION
            </button>
          )}
        </footer>
      </PageContent>
    );
  }
}

export default connect(
  (state) => {
    return {
      retries: state.faceCapture.retries,
      faceQualityHostname: state.configuration.faceQualityHostname,
    };
  },
  { preview, toggleNetworkWarnings }
)(PageFaceCapture);
